/** Role badge colors keyed by normalized role name. */
const ROLE_COLORS_BY_NAME = {
  qa: "#17c1e8",
  dev: "#82d616",
  pm: "#fb6340",
  admin: "#7928ca",
  mobile: "#7928ca",
  lead: "#5e72e4",
  manager: "#f59e0b",
  outsource: "#6c757d",
  vendor: "#fd7e14",
};

/** Legacy numeric role_id fallbacks (when role_name is missing). */
const ROLE_COLORS_BY_ID = {
  1: "#17c1e8",
  2: "#82d616",
  3: "#fb6340",
  4: "#7928ca",
};

const DEFAULT_ROLE_STYLE = "background:#e9ecef;color:#344767;";

function normalizeRoleName(roleName) {
  return String(roleName || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

/**
 * Inline style for role badges (Admin Setting, Profile, etc.).
 * @param {number|string} roleId
 * @param {string} [roleName]
 */
export function roleBadgeStyle(roleId, roleName) {
  const name = normalizeRoleName(roleName);
  if (name && ROLE_COLORS_BY_NAME[name]) {
    return `background:${ROLE_COLORS_BY_NAME[name]};color:#fff;`;
  }
  const id = Number(roleId);
  if (id && ROLE_COLORS_BY_ID[id]) {
    return `background:${ROLE_COLORS_BY_ID[id]};color:#fff;`;
  }
  return DEFAULT_ROLE_STYLE;
}

export function roleColorHex(roleId, roleName) {
  const name = normalizeRoleName(roleName);
  if (name && ROLE_COLORS_BY_NAME[name]) return ROLE_COLORS_BY_NAME[name];
  const id = Number(roleId);
  if (id && ROLE_COLORS_BY_ID[id]) return ROLE_COLORS_BY_ID[id];
  return null;
}
